import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, hideElement, addClass, removeClass, toggleClass, findAll, isVisible, hasClass } from '@fretadao/f-js-dom';

application.register('line-show', class extends Controller {
  static classes = ['even', 'hover', 'active'];
  static targets = ['filters'];

  connect() {
    const allOption = find('[data-option-default]');
    const targetInput = find('[data-option]', allOption);

    this.setFilterOptionAsActive(allOption, 'data-checked');
    this.setRadioButtonChecked(targetInput);
    this.applyClass('firstTime');
  }

  applyClass(firstTimeToShow='') {
    const table = find('[data-element="table"]').tBodies[0];

    if(firstTimeToShow === 'firstTime') {
      table.rows.forEach((row, index) => {
        if((index % 2 === 0) && !hasClass(row, this.evenClass)) {
          addClass(row, this.evenClass)
        }
        else if((index % 2 !== 0) && hasClass(row, this.evenClass)) {
          removeClass(row, this.evenClass);
        }
      })
    }
    else {
      var nextVisibleLine = true
      table.rows.forEach((row) => {
        if (isVisible(row)) {
          if(nextVisibleLine) {
            if(!hasClass(row, this.evenClass)) {
              addClass(row, this.evenClass)
            }
            nextVisibleLine = false
          }
          else {
            if(hasClass(row, this.evenClass)) {
              removeClass(row, this.evenClass);
            }
            nextVisibleLine = true
          }
        }
      })
    }
  }

  tableSort() {
    this.applyClass();
    this.hideFilters();
  }

  dataChanged() {
    this.applyClass();
  }

  hideFilters() {
    hideElement(this.filtersTarget);
  }

  applyCurrentFilterClasses(event) {
    const targetDiv = event.currentTarget;
    const targetInput = find('[data-option]', targetDiv);

    if(targetInput) {
      this.setRadioButtonChecked(targetInput);
    }

    this.hideFilters();
    this.setFilterOptionAsActive(targetDiv, 'data-checked');
  }

  setRadioButtonChecked(targetInput) {
    const radios = findAll('[data-option]');
    radios.forEach((rad) => {
      rad.removeAttribute('checked');
    });
    targetInput.setAttribute('checked', true);
  }

  setFilterOptionAsActive(el, dataName) {
    const currentActiveEl = find(`[${dataName}="true"]`);

    if (currentActiveEl !== null) {
      currentActiveEl.removeAttribute(dataName);
      toggleClass(currentActiveEl, this.hoverClass);
      toggleClass(currentActiveEl, this.activeClass);
    }

    el.setAttribute(dataName, true);
    toggleClass(el, this.hoverClass);
    toggleClass(el, this.activeClass);
  }

  getTableRows() {
    const table = find('[data-element="table"]');
    const tableBody = table.tBodies[0];
    return Array.prototype.slice.call(tableBody.rows, 0);
  }
});
